import { ref } from 'vue';

import { useFlashesStore } from '@/stores';

import useBilling from './useBilling';

export function useChargify() {
  const loading = ref(true);

  // @ts-expect-error we dont have access to the chargify client type
  const chargifyClient = new Chargify();
  const chargifyForm = ref<HTMLElement | null>(null);

  function getToken() {
    const form = chargifyForm.value;
    return new Promise((resolve, reject) => {
      chargifyClient.token(
        form,
        (token: Promise<string>) => {
          resolve(token);
        },
        (error: Promise<Error>) => {
          reject(error);
        },
      );
    });
  }

  const flashesStore = useFlashesStore();
  const { editPaymentMethod } = useBilling();

  const needsCustomerAction = ref(false);
  async function handleGetToken(onSuccess?: () => void, onError?: () => void) {
    try {
      loading.value = true;
      const token = await getToken();
      needsCustomerAction.value = false;
      editPaymentMethod({
        token: token as string,
      });
      // editPaymentMethod already contains a success message
      if (onSuccess) onSuccess();
    } catch (err) {
      flashesStore.addErrorFlash('Failed to update payment information');
      if (onError) onError();
    } finally {
      loading.value = false;
    }
  }

  function onLoaded() {
    loading.value = false;
  }

  return {
    loading,
    chargifyClient,
    chargifyForm,
    getToken,
    handleGetToken,
    onLoaded,
  };
}
